import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyChangedFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  const filteredRoisIds = Array.from(ctx.previousRoiIds).filter((id) =>
    step.value === 'true' ? ctx.changedRois.has(id) : !ctx.changedRois.has(id)
  );
  return new Set(filteredRoisIds);
}
